<template>
  <div class="col-12 col-md-5 col-lg-4 col-xl-3  order-xl-2 graph-xl-col-3 section-graph__fix_mob_padding">
    <div class="graph-and-filters">
      <div class="graph-auto">
        <div class="graph-auto__wrapp u-img text-center">
          <div class="u-img__date">
                <span>
                  <svg x="0px" y="0px" viewBox="-223 25 512 512" style="enable-background:new -223 25 512 512;">
                    <g>
                        <g>
                            <path class="st0" d="M124.2,326.2l-71.4-53.5V163.6c0-11-8.9-19.8-19.8-19.8c-11,0-19.8,8.9-19.8,19.8v119
                                c0,6.2,2.9,12.1,7.9,15.9l79.3,59.5c3.6,2.7,7.7,4,11.9,4c6,0,12-2.7,15.9-8C134.8,345.2,133,332.8,124.2,326.2z"/>
                        </g>
                    </g>
                    <g>
                        <g>
                            <path class="st0" d="M33,25c-141.2,0-256,114.8-256,256s114.8,256,256,256s256-114.8,256-256S174.2,25,33,25z M33,497.3
                                c-119.3,0-216.3-97.1-216.3-216.3S-86.3,64.7,33,64.7c119.3,0,216.3,97.1,216.3,216.3S152.3,497.3,33,497.3z"/>
                        </g>
                    </g>
                  </svg>
                  {{date}}</span></div>
          <div class="u-img__img"><img :src="frame" alt=""></div>
          <div class="u-img__button"><span @click="openGallery">Все фото</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Photo',
  components: {

  },
  data () {
    return {
      frame: null,
      polling: null,
      date: null,
      id: null
    }
  },
  created () {
    const station = this.$store.getters[ 'station/station' ]
    this.id = station.id

    this.getFrame()
    this.polling = setInterval(this.getFrame, 1000 * 120)
  },
  beforeDestroy () {
    clearInterval(this.polling)
  },
  methods: {
    getFrame () {
      axios.get(`https://tel.pvcontrol.solar/pvcontrol/api/snapshot?stationId=${this.id}`)
        .then(r => {
          this.frame = r.data.filename
          this.date = r.data.date
        }).catch(() => {
          if (this.polling !== null) {
            clearInterval(this.polling)
            this.polling = null
          }
        })
    },
    openGallery () {
      this.$router.push({
        name: 'gallery',
        id: this.$route.params.id
      })
    }
  }
}
</script>
